import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { Providers } from './providers.tsx'
import './styles/globals.css'
import './lib/aws-config'
import { authService, initWebInterceptSurvey } from '@bri/shared-components'

// Configure the API URL for authService
const apiUrl = import.meta.env.VITE_API_URL || 'https://jz6jdvym87.execute-api.us-east-1.amazonaws.com/dev';
authService.setApiUrl(apiUrl);
initWebInterceptSurvey(import.meta.env.VITE_ENVIRONMENT);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Providers>
        <App />
      </Providers>
    </BrowserRouter>
  </React.StrictMode>,
)
